module.exports = __webpack_public_path__ + "img/2.01815c91.png";